// import { getWalletScriptUrl } from '../constants/globalConstants'
export const loadScript = (src, position, callBack) => {
    if (!position) {
      return
    }
    const script = document.createElement('script')
    // script.setAttribute('async', '')
    // script.setAttribute('id', id)
    script.src = src
    position.appendChild(script)
    script.onload = () => {  
        if (callBack) callBack()
    }
  }
  
  export const addScript = (loaded, scriptSrc, callBack) => {
    if (typeof window !== 'undefined' && !loaded.current) {
        loadScript(scriptSrc, document.querySelector('head'), callBack)
    }
  }
  
  // export const loadScriptUrl = (loaded, paymentGateway) => {
    
  // }